import createCachedSelector from 're-reselect';
import { connect } from 'react-redux';
import * as chartSelectors from 'state/selectors/chart';
import TimeSeriesChart from '../../../components/chart/TimeSeriesChart';
import * as fromState from '../../../state/reducers';
import { transformChartTypeSelectors } from '../../../utils/helpers';

const mapStateToProps = createCachedSelector(
  transformChartTypeSelectors([
    fromState.getChartIsLoading,
    chartSelectors.getTrendTimelineHeight
  ]),
  (isLoading, trendTimelineHeight) => ({
    isLoading,
    trendTimelineHeight
  })
)(
  (state, { chartType }) => chartType
);

export default connect(mapStateToProps)(TimeSeriesChart);